<template>
  <!--新增嘉宾-->
  <div class="content newGuest">
    <div class="layui-fluid">
      <div class="layui-row">
        <div class="layui-col-md12">
          <div class="layui-row" style="margin-top: 20px;">
            <div class="layui-col-md12">
              <form class="layui-form" action lay-filter="example">
                <div class="layui-form-item">
                  <label class="layui-form-label">姓名:</label>
                  <div class="layui-input-block">
                    <input
                      type="text"
                      name="name"
                      lay-verify="required"
                      autocomplete="off"
                      placeholder="请输入姓名"
                      class="layui-input"
                    />
                  </div>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">工作单位:</label>
                  <div class="layui-input-block">
                    <input
                      type="text"
                      name="company"
                      autocomplete="off"
                      placeholder="请输入工作单位"
                      class="layui-input"
                    />
                  </div>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">手机号:</label>
                  <div class="layui-input-block">
                    <input
                      type="text"
                      name="tel"
                      autocomplete="off"
                      placeholder="请输入手机号"
                      class="layui-input"
                    />
                  </div>
                </div>
                <div class="layui-form-item layui-form-text">
                  <label class="layui-form-label">研究领域:</label>
                  <div class="layui-input-block">
                    <textarea name="domain" placeholder="请输入研究领域" class="layui-textarea"></textarea>
                  </div>
                </div>
                <div class="layui-form-item layui-form-text">
                  <label class="layui-form-label">简介:</label>
                  <div class="layui-input-block">
                    <textarea name="description" placeholder="请输入简介" class="layui-textarea"></textarea>
                  </div>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">头像:</label>
                  <div class="layui-input-block">
                    <button
                      type="button"
                      class="layui-btn"
                      @click="handleUploadConferenceCover"
                    >上传图片</button>
                    <input
                      type="file"
                      name="head_img"
                      class="layui-input"
                      id="testlogos"
                      style="display: none;"
                      @change="uploads"
                    />
                    <p
                      class="layui-elip"
                      style="color: red;font-size: 12px;margin-top: 10px;"
                    >仅支持png、jpg格式头像，大小不超过3m</p>
                    <div class="layui-input-list" style="margin: 10px 0px;">
                      <img
                        class="layui-upload-img"
                        id="demosGuest"
                        width="60"
                        height="60"
                        style="display: none"
                      />
                    </div>
                    <div>
                      <button type="button" v-if="cover_url != ''"  class="layui-btn layui-btn-sm" @click="removeImg">清除</button>
                    </div>
                  </div>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">学者ssapid:</label>
                  <div class="layui-input-block">
                    <input
                      type="text"
                      name="ssapid"
                      autocomplete="off"
                      placeholder="请输入学者ssapid"
                      class="layui-input"
                    />
                  </div>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">作者:</label>
                  <div class="layui-input-block">
                    <input type="text" class="layui-input" name="author_id" v-model="backAuthor.name" v-show="backAuthor != ''" style="max-width:200px;float:left;" disabled>
                    <button class="layui-btn " @click="autor">选择作者</button>
                  </div>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">简介配置:</label>
                  <div class="layui-input-block">
                    <input type="radio" name="config_description" value="0" title="使用作者信息" checked>
                    <input type="radio" name="config_description" value="1" title="使用嘉宾信息" >
  </div>
                </div>
                <div class="layui-form-item" style="text-align: center;">
                  <button type="button" class="layui-btn" lay-submit lay-filter="saveNewGuest">保存</button>
                  <button
                    type="button"
                    class="layui-btn layui-btn-primary"
                    id="sharemanagement"
                    @click="back"
                  >取消</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisibleFour" :modal-append-to-body="false">
      <div class="layui-form-item" style="text-align: center">
        <div class="layui-input-inline">
          <input type="text" name="title" required lay-verify="required" v-model="searchName" placeholder="请输入搜索姓名" autocomplete="off" class="layui-input">
        </div>
        <div class=" layui-input-inline" style="text-align:left;">
          <button type="button" class="layui-btn layui-btn-normal" @click="searchAuthor">搜索</button>
        </div>

      </div>
      <table class="layui-hide" id="test2"></table>
      <div id="author_pagebox"></div>
      <div class="layui-form-item" style="text-align: center">
        <button type="button" class="layui-btn" id="handleDetermine" @click="sub">确定</button>
        <button type="reset" class="layui-btn layui-btn-primary" @click="dialogFormVisibleFour = false">取消</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "NewGuest",
  data() {
    return {
      msg: "",
      title:'',
      cover_url: "",
      tid: "",
      dialogFormVisibleFour: false,
      searchName:'',//搜索人员名称
      backAuthor:'',//选中的作者
      page:1,//作者库
      pagesize:10,//每页条数作者库
    };
  },
  created() {
    this.tid = this.$route.query.id;
  },
  methods: {
    /* 判断是否是编辑进入 */
    bianji() {
      var _this = this;
      layui.use(
        [
          "jquery",
          "element",
          "form",
          "laydate",
          "upload",
          "layedit",
          "layer",
          "table",
        ],
        function () {
          var layer = layui.layer;
          var $ = layui.jquery;
          var element = layui.element;
          var form = layui.form;
          var laydate = layui.laydate;
          var upload = layui.upload;
          var nowTime = new Date().valueOf();
          var table = layui.table;
          var layedit = layui.layedit;
          if (_this.tid != undefined) {
            let url = "/ac1/conference/guest/detail";
            var params = {
              id: _this.tid,
            };
            _this.$get(url, params).then(res => {
              var lin = res.posts;
              console.log(lin); 
              var obj={
                name:lin.name,
                company:lin.company,
                tel:lin.tel,
                description:lin.description,
                domain:lin.domain,
                ssapid:lin.ssapid,
                author_id:lin.author_id,
                config_description:lin.config_description,
              }           
              var img = lin.head_img;
              if(lin.author_id != ''){
                _this.backAuthor = {
                  name:lin.author_name,
                  id:lin.author_id
                }
              }
              if(img != ''){
                $("#demosGuest").show()
                $("#demosGuest").attr("src", img);
                _this.cover_url = $("#demosGuest").attr("src");
              }
              form.val("example", obj);        

            });
          }
        }
      );
    },
    handleUploadConferenceCover() {
      $("#testlogos").click();
    },
    uploads(e) {
      let _this = this;
      let file = e.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        // 读取到的图片base64 数据编码 将此编码字符串传给后台即可
        let params = { base64: e.target.result };
        let url = "/v1/SaveFile/base64";
        _this
          .$postform(url, params)
          .then((res) => {
            console.log(res);
            if (parseInt(res.code) === 1) {
              _this.$message({
          message: '上传成功',
          type: 'success',
          duration:1000
        });
              $("#demosGuest").css({ display: "block" });
              $("#demosGuest").attr(
                "src",
                res.posts[0].domain + "/" + res.posts[0].image
              );
              var src = res.posts[0].image;
              _this.cover_url = src;
              console.log($("#demosGuest").attr("src"));
            } else {
              layer.msg(res.msg);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      };
    },
    back() {
      this.$router.push({ path: "/Guest/GuestManagement" });
    },
    removeImg(){
      let _this = this;
      _this.cover_url = '';
      $(".layui-upload-img").hide();
    },
    // 公共方法
    handlePublics() {
      let _this = this;
      this.$nextTick(() => {
        layui.use(["jquery", "element", "table", "form"], function () {
          var $ = layui.jquery;
          var element = layui.element;
          var form = layui.form;
          var table = layui.table;
          form.on("submit(saveNewGuest)", function (data) {
            let url = "/ac1/conference/guest";
            let params={}
            if(_this.tid){
              params = {
              id:_this.tid,
              name: data.field.name,
              company: data.field.company,
              tel: data.field.tel,
              domain: data.field.domain,
              description: data.field.description,
              head_img: _this.cover_url,
              ssapid: data.field.ssapid,
                author_id:_this.backAuthor.id,
                config_description:data.field.config_description,
            };
            }else{
              params = {           
              name: data.field.name,
              company: data.field.company,
              tel: data.field.tel,
              domain: data.field.domain,
              description: data.field.description,
              head_img: _this.cover_url,
              ssapid: data.field.ssapid,
                author_id:_this.backAuthor.id,
                config_description:data.field.config_description,
            };
            }
            _this
              .$post(url, params)
              .then((res) => {
                console.log(res);
                if (res.code == "1") {
                  _this.$message({
          message: '保存成功',
          type: 'success',
          duration:1000
        });
                  _this.$router.push({ path: "/Guest/GuestManagement" });
                } else {
                  layer.msg("请填写完整信息");
                }
              })
              .catch((error) => {
                console.log(error);
              });
          });
          element.render();
          form.render();
          table.render();
        });
      });
    },
    /* 作者库 */
    autor () {
      var _this = this;
      layui.use(["jquery", "element", "form", "table","laypage"], function () {
        var $ = layui.jquery;
        var element = layui.element;
        var form = layui.form;
        var table = layui.table;
        var laypage = layui.laypage;
        //先晓作者库弹窗
        _this.dialogFormVisibleFour = true;
        _this.title = "选择作者";
        let url = "/ac1/conference/authorLib";
        _this.$get(url,{name:_this.searchName,page:_this.page,pagesize:_this.pagesize}).then((res) => {
          let tableAry = [];
          for (let i = 0; i < res.posts.hits.length; i++)
          {
            tableAry.push(res.posts.hits[i]._source);
          }
          console.log("作者库", res);

          if (res.code == "1")
          {
            if(_this.page == 1){
              laypage.render({
                elem: 'author_pagebox' //注意，这里的 test1 是 ID，不用加 # 号
                ,count: res.posts.total.value //数据总数，从服务端得到
                ,limit:_this.pagesize
                ,jump: function(obj, first){
                  // console.log(obj.curr); //得到当前页，以便向服务端请求对应页的数据。
                  //  console.log(obj.limit); //得到每页显示的条数
                  //首次不执行
                  if(!first){
                    //do something
                    _this.page = obj.curr;
                    _this.autor();
                  }
                }
              });
            }
            table.render({
              elem: "#test2",
              data: tableAry,
              text: {
                none: "暂无相关数据", //默认：无数据。
              },
              response: {
                statusName: "code", //规定数据状态的字段名称，默认：code
                statusCode: 1, //规定成功的状态码，默认：0
                msgName: "hint", //规定状态信息的字段名称，默认：msg
                countName: "total", //规定数据总数的字段名称，默认：count
                dataName: "posts", //规定数据列表的字段名称，默认：data
              },
              cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
              cols: [
                [
                  { type: "radio" },
                  { field: "id", title: "ID" },
                  {
                    field: "head_img",
                    title: "嘉宾头像",
                    templet: '<div><img src="{{d.head_img}}"></div>',
                  },
                  { field: "name", title: "姓名" },
                  { field: "ssap_id", title: "ssapid" },
                  { field: "abstracts", title: "简介" },
                  { field: "domain", title: "研究领域" },
                ],
              ],
              page: false,
            });
          } else
          {
            console.log(res.msg);
          }
        });
      });
    },
    searchAuthor(){
      this.page = 1;
      this.autor();
    },
    /* 提交 */
    sub () {
      var _this = this;
      layui.use(["jquery", "element", "form", "table",  "layer",], function () {
        var layer = layui.layer;
        /*选中的数据*/
        let checkStatus = layui.table.checkStatus("test2").data;
        if(checkStatus.length > 0){
          _this.dialogFormVisibleFour = false;
          _this.backAuthor = checkStatus[0];
        }else{
          layer.msg('请选择作者');
        }
      });
    },
  },
  mounted() {
    // 公共方法
    this.handlePublics();
    this.bianji()
  },
  updated() {
 
  },
};
</script>

<style scoped>
.newGuest .layui-form-label {
  width: 110px;
}
</style>
